module.exports = __webpack_public_path__ + "src/components/ViewListing/ListingIntro/hotel.svg?4bd2b5ea";


//////////////////
// WEBPACK FOOTER
// ./src/components/ViewListing/ListingIntro/hotel.svg
// module id = 3124
// module chunks = 8